import { ChangeEvent, useContext, useState } from 'react';
import { SearchField, useGetWorkshifts } from '../../../../common';
import { AppContext } from '../../../../common/context/';
import { Modal } from '../BaseModal';
import { workshiftSchedulingProps } from './WorkshiftScheduling.Props';

export const WorkshiftSchedulingModal = ({
    isOpen,
    saveWorkshiftsScheduling,
}: workshiftSchedulingProps) => {
    const {
        langResources,
        isSkinSmart,
        workshiftUsed,
        setWorkshiftUsed,
        workshiftList,
        workshiftListCopy,
        setWorkshiftListCopy,
        isLoadingDataList,
        modalInfoWorkshift,
        setIsOpenWorkshiftModal,
        setModalInfoWorkshift,
    } = useContext(AppContext);

    const [searchTerm, setSearchTerm] = useState('');
    const [workshiftSelected, setWorkshiftSelected] = useState<number>(-1);
    const [isCollapse, setIsCollapse] = useState(true);

    const { workshiftDetails, isLoadingDataDetails, setIsLoadingData } =
        useGetWorkshifts(workshiftSelected);

    const handlerChangeTypeWorkshift = (e: ChangeEvent<HTMLInputElement>) => {
        let nameOfWorkshift = e.target.value;

        setSearchTerm(nameOfWorkshift);

        const workshiftFiltered = workshiftList?.filter(
            (w) =>
                w.name.toLowerCase().includes(nameOfWorkshift.toLowerCase()) ||
                w.alias.toLowerCase().includes(nameOfWorkshift.toLowerCase())
        );

        setWorkshiftListCopy(workshiftFiltered);
    };

    const handlerCloseModal = () => {
        window.localStorage.removeItem('selection-range');
        setIsOpenWorkshiftModal(false);
    };

    const handleResetSearchTerm = () => {
        setSearchTerm('');
        setWorkshiftListCopy(workshiftList);
    };

    const handlerSelectWorkshift = (id: number) => {
        setIsLoadingData(true);
        setWorkshiftSelected(id);
    };

    const handlerSubmit = () => {
        let newWorkshifts: number[] = [...workshiftUsed];

        if (workshiftUsed.length > 4) {
            newWorkshifts.shift();
        }
        if (!newWorkshifts.includes(workshiftSelected)) {
            newWorkshifts.push(workshiftSelected);
        }
        setWorkshiftUsed(newWorkshifts);
        saveWorkshiftsScheduling(workshiftSelected);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle=''
            onClose={handlerCloseModal}
            onSubmit={handlerSubmit}
            disableSubmit={workshiftSelected === -1}
        >
            <div className='modal-body' style={{ paddingBottom: 0, minHeight: 450 }}>
                <div className='row'>
                    {!isLoadingDataList ? (
                        <div className='col-3'>
                            <SearchField
                                selectItemId={handlerChangeTypeWorkshift}
                                inputPlaceholder={
                                    langResources['create.workshift.Modal'][
                                        'select.workshift.placeholder'
                                    ]
                                }
                                labelTitle={''}
                                searchTerm={searchTerm}
                                handleResetSearchTerm={handleResetSearchTerm}
                                dataListId=''
                            />

                            <div
                                className=''
                                style={{
                                    maxHeight: 380,
                                    minHeight: 250,
                                    overflowY: 'scroll',
                                }}
                            >
                                <ul className='list-group list-group-flush'>
                                    {workshiftListCopy?.map((w) => (
                                        <li
                                            onClick={() =>
                                                handlerSelectWorkshift(w.id)
                                            }
                                            className={`list-group-item p-1 px-3 text-selected ${
                                                workshiftSelected === w.id &&
                                                'text-selected--active'
                                            }`}
                                            key={w.id}
                                            title={w.name}
                                            style={{
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {w.alias} - {w.name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ) : (
                        <div className='col-3'>
                            <h5 className='card-title placeholder-glow'>
                                <span className='placeholder col-6'></span>
                            </h5>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-12 bg-dark'></span>
                            </p>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-7 bg-dark'></span>
                            </p>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-12 bg-dark'></span>
                            </p>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-7 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                            </p>

                            <p className='card-text placeholder-glow'>
                                <span className='placeholder col-7 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                                <span className='placeholder col-4 bg-dark'></span>
                            </p>
                        </div>
                    )}

                    <div className='col-9'>
                        <div className='row'>
                            <div className='col-12'>
                                <h5 className={`text-primary2`}>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'details.title'
                                        ]
                                    }
                                </h5>
                            </div>

                            <div className='col-4'>
                                <p>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'workshift.name'
                                        ]
                                    }
                                    : {workshiftDetails?.name}
                                </p>

                                <p style={{ marginTop: '-15px' }}>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'double.title'
                                        ]
                                    }
                                    :{' '}
                                    {workshiftDetails?.isDuplex
                                        ? langResources['msg.yes']
                                        : langResources['msg.no']}
                                </p>

                                <p style={{ marginTop: '-15px' }}>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'isNextTurn'
                                        ]
                                    }
                                    :{' '}
                                    {workshiftDetails?.isNextTurn
                                        ? langResources['msg.yes']
                                        : langResources['msg.no']}
                                </p>

                                <p style={{ marginTop: '-15px' }}>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'isOnlyExtra'
                                        ]
                                    }
                                    :{' '}
                                    {workshiftDetails?.isExtra
                                        ? langResources['msg.yes']
                                        : langResources['msg.no']}
                                </p>

                                {workshiftDetails?.isAutomaticDiscount && (
                                    <p style={{ marginTop: '-15px' }}>
                                        {
                                            langResources['create.workshift.Modal'][
                                                'automatic.discount'
                                            ]
                                        }
                                        :{' '}
                                        {
                                            workshiftDetails.timeAutomaticDiscount.split(
                                                'T'
                                            )[1]
                                        }
                                    </p>
                                )}
                            </div>

                            <div className='col-3'>
                                <p className='text-muted fs-6'>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'starDate'
                                        ]
                                    }
                                    :
                                    <br />
                                    {modalInfoWorkshift?.startDate}
                                </p>
                            </div>

                            <div className='col-3'>
                                <p className='text-muted fs-6'>
                                    {
                                        langResources['create.workshift.Modal'][
                                            'endDate'
                                        ]
                                    }
                                    :
                                    <br />
                                    {modalInfoWorkshift?.endDate}
                                </p>
                            </div>
                        </div>

                        <div className='row'>
                            <table className='table position-relative'>
                                <thead className='text-dark'>
                                    <tr>
                                        <th scope='col' className='p-2 px-3'>
                                            {
                                                langResources[
                                                    'create.workshift.Modal'
                                                ]['day']
                                            }
                                        </th>
                                        {workshiftDetails?.isDuplex ? (
                                            <>
                                                <th scope='col' className='p-2 px-3'>
                                                    {
                                                        langResources[
                                                            'create.workshift.Modal'
                                                        ]['scheduling1']
                                                    }
                                                </th>
                                                <th scope='col' className='p-2 px-3'>
                                                    {
                                                        langResources[
                                                            'create.workshift.Modal'
                                                        ]['scheduling2']
                                                    }
                                                </th>
                                            </>
                                        ) : (
                                            <>
                                                <th scope='col' className='p-2 px-3'>
                                                    {
                                                        langResources[
                                                            'create.workshift.Modal'
                                                        ]['entry']
                                                    }
                                                </th>
                                                <th scope='col' className='p-2 px-3'>
                                                    {
                                                        langResources[
                                                            'create.workshift.Modal'
                                                        ]['exit']
                                                    }
                                                </th>
                                            </>
                                        )}

                                        <th scope='col' className='p-2 px-3 text-center'>
                                            {
                                                langResources[
                                                    'create.workshift.Modal'
                                                ]['isNextDay']
                                            }
                                        </th>
                                    </tr>
                                </thead>

                                <span
                                    className='position-absolute text-muted fs-3 btn btn-small border-0'
                                    style={{ right: 0, top: 0 }}
                                    onClick={() => setIsCollapse(!isCollapse)}
                                >
                                    <i
                                        className={
                                            isCollapse
                                                ? 'ri-arrow-drop-up-line'
                                                : 'ri-arrow-drop-down-line'
                                        }
                                    ></i>
                                </span>

                                {isCollapse && (
                                    <tbody>
                                        {workshiftDetails?.workshiftsDayList.map(
                                            (turnFix) => (
                                                <tr
                                                    key={turnFix.name}
                                                    className='text-muted '
                                                >
                                                    <th className='p-1 px-3'>
                                                        {turnFix.name}
                                                    </th>
                                                    {workshiftDetails.isDuplex ? (
                                                        <>
                                                            <th className='p-1 px-3'>
                                                                {turnFix.checkInTime}{' '}
                                                                -{' '}
                                                                {
                                                                    turnFix.departureTime
                                                                }
                                                            </th>
                                                            <th className='p-1 px-3'>
                                                                {
                                                                    turnFix.checkInTime2
                                                                }{' '}
                                                                -{' '}
                                                                {
                                                                    turnFix.departureTime2
                                                                }
                                                            </th>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <th className='p-1 px-3'>
                                                                {turnFix.checkInTime}
                                                            </th>
                                                            <th className='p-1 px-3'>
                                                                {
                                                                    turnFix.departureTime2
                                                                }
                                                            </th>
                                                        </>
                                                    )}

                                                     <th className='p-1 px-3 text-center'>
                                                        {turnFix.isNextDay 
                                                            ? langResources['msg.yes']
                                                            : langResources['msg.no']}
                                                    </th>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                )}
                            </table>
                        </div>

                        <div className='col-12'>
                            <h5 className={`text-primary2`}>
                                {langResources['create.allowance.Modal']['title']}
                            </h5>
                        </div>

                        <div className='row'>
                            {' '}
                            <table className='table position-relative'>
                                <thead className='text-dark'>
                                    <tr>
                                        <th scope='col' className='p-2 px-3'>
                                            {
                                                langResources[
                                                    'create.allowance.Modal'
                                                ]['typeDescription']
                                            }
                                        </th>

                                        <th scope='col' className='p-2 px-3'>
                                            {
                                                langResources[
                                                    'create.allowance.Modal'
                                                ]['name']
                                            }
                                        </th>

                                        <th scope='col' className='p-2 px-3'>
                                            {
                                                langResources[
                                                    'create.allowance.Modal'
                                                ]['description']
                                            }
                                        </th>

                                        <th scope='col' className='p-2 px-3'>
                                            {
                                                langResources[
                                                    'create.allowance.Modal'
                                                ]['concept']
                                            }
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {workshiftDetails?.workshifstAllowances.map(
                                        (allowance) => (
                                            <tr
                                                key={allowance.name}
                                                className='text-muted '
                                            >
                                                <th className='p-1 px-3'>
                                                    {allowance.typeDescription}
                                                </th>
                                                <th className='p-1 px-3'>
                                                    {allowance.name}
                                                </th>
                                                <th className='p-1 px-3'>
                                                    {allowance.description}
                                                </th>
                                                <th className='p-1 px-3'>
                                                    {allowance.concept}
                                                </th>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
